import React from 'react';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

export default ({
  classes,
  arrowRight,
  settingsIcon,
  mwRedirectEmail,
  verificationMess,
  verificationMessage,
  autogeneratedMWEmail,
}) => {
  return (
    <div className={classes.descriptionFont}>
      <div className={`${classes.p20}`} style={{ border: '1px dashed #DBD9E7', backgroundColor: '#F1F1F6', margin: '0px 20px 20px 20px' }}>
        <span>
          ⚠️ Be aware that Gmail has a daily <a href="https://support.google.com/a/answer/166852?hl=en" target="_blank" rel="noreferrer">forwarding limit</a> of 10,000 emails. Once this limit is reached, emails will stop forwarding. <br></br>
            Therefore, we recommend sending emails from load boards directly to Milkyweb and using&nbsp;
            <span
              className={`${classes.textInfo} ${classes.pointer} ${classes.nowrap}`}
              onClick={() => window.open(`http://${window.location.host}/tutorial#gmail_filter`, "_blank")}
            >
              filter
              <OpenInNewRoundedIcon className={classes.iconInfo}/>
            </span>
            
            &nbsp;to forward other emails from your mailbox.
        </span>
      </div>
      <div style={{ fontSize: 18, flexGrow: 1, color: '#4c4c4c', fontWeight: 600 }}><span>How to set up Gmail redirect:</span></div>
      <li>1. On your computer, open <a className={classes.iconInfo} href="https://mail.google.com/" target="_blank" rel="noopener noreferrer">Gmail <OpenInNewRoundedIcon className={classes.iconInfo}/></a> using the account you want to forward messages from. You can only forward messages for a single Gmail address, and not an email group or alias.</li>
      <div style={{ margin: '10px 0' }}>
        <img
          title='google redirect manual'
          alt='google manual'
          width='100%'
          height='auto'
          border='none'
          src='https://storage.googleapis.com/support-kms-prod/Cm6cYtX7pQvTaMzx3ADskquczoegpK3vShee'>
        </img>
      </div>
      <li className={classes.alignCenter}>2. In the top right, click Settings&nbsp;
        {settingsIcon}
        {arrowRight}
        <strong>See all settings.&nbsp;</strong>
      </li>
      <li>3. Click the <strong>Forwarding and POP/IMAP</strong> tab.</li>
      <li>4. In the "Forwarding" section, click <strong>Add a forwarding address</strong>.</li>
      <li>5. Enter the email address {mwRedirectEmail ? mwRedirectEmail : autogeneratedMWEmail()}.</li>
      <li className={classes.alignCenter}>6. Click &nbsp;<strong>Next</strong>
        {arrowRight}
        <strong>Proceed</strong>
        {arrowRight}
        <strong>OK</strong>.</li>
      <li>7. <strong> A {verificationMessage && verificationMess ? verificationMess() : 'Redirect verification message'} will appear {verificationMess ? 'below' : 'in the dashboard instruction' }. We need you to click the confirmation verification link in that message and accept forwarding.</strong></li>
      {verificationMess ? verificationMess : null}
      <li>8. Go back to the settings page for your Gmail account and refresh your browser.</li>
      <li>9. Click the&nbsp;<strong>Forwarding and POP/IMAP</strong>&nbsp;tab.</li>
      <li>10. In the "Forwarding" section, set <strong>Forward a copy of incoming mail to</strong>&nbsp;{mwRedirectEmail ? mwRedirectEmail : autogeneratedMWEmail()}.</li>
      <li>11. Choose what you want to happen with the Gmail copy of your emails. We recommend Keep Gmail's copy in the Inbox.</li>
      <li>12. At the bottom of the page, click <strong>Save Changes</strong>.</li>
    </div>
  );
};
